import { useEffect, useRef } from "react";

export default function ProctorCameraPreview() {
  const videoRef = useRef(null);

  useEffect(() => {
    let stream;

    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((s) => {
        stream = s;
        videoRef.current.srcObject = stream;
      })
      .catch(() => {
        console.warn("Camera access failed");
      });

    return () => {
      if (stream) {
        stream.getTracks().forEach((t) => t.stop());
      }
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      className="w-full h-48 rounded-lg border border-white/20 object-cover"
    />
  );
}
